import { SUB_JOB_RECEIVE_REQUEST, CREATE_SUB_JOB_RECEIVE, GET_SUB_JOB_RECEIVES, UPDATE_SUB_JOB_RECEIVE, DELETE_SUB_JOB_RECEIVE,
    SUB_JOB_RECEIVE_REQUEST_FAILURE } from '../types';

const initialState = {
  subJobReceives: [],
  loading: false,
  error: null,
};

const subJobReceiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_JOB_RECEIVE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SUB_JOB_RECEIVES: {
      return {
        ...state,
        subJobReceives: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_SUB_JOB_RECEIVE:
      return {
        ...state,
        subJobReceives: [action.payload, ...state.subJobReceives],
        loading: false,
        error: null
      };
    case UPDATE_SUB_JOB_RECEIVE:
      const subJobReceivesData = state.subJobReceives.slice(0);
      const uIndex = subJobReceivesData.findIndex((data) => data.id === action.payload.id);
      subJobReceivesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        subJobReceives: [ ...subJobReceivesData ],
        loading: false,
        error: null
      };
    case DELETE_SUB_JOB_RECEIVE:
      const subJobReceives = state.subJobReceives?.slice(0);
      const index = subJobReceives.findIndex((data) => data.id === action.id);
      if (index > -1) {
        subJobReceives.splice(index, 1);
      }
      return {
        ...state,
        subJobReceives: [...subJobReceives],
        loading: false,
        error: null
      }
    case SUB_JOB_RECEIVE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default subJobReceiveReducer;
